var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.108 11.4373L0.6026 8.71855L9.10684 15.2061L17.6192 8.71855L9.10453 11.4373H9.108ZM9.23736 0.206055L0.72965 7.84543L9.2362 10.5667L17.7428 7.84793L9.23736 0.206055Z",
    fill: "#FF4267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailI);
export default __webpack_public_path__ + "static/media/failI.0f2ad2f5f2bfa94264f66e91777d2d50.svg";
export { ForwardRef as ReactComponent };